import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";
import { useGlobalContext } from "../../GlobalContext";
import BaseComponent, { BaseProps } from "../BaseComponent";

export default function BaseApplicationComponent(props: BaseProps) {
  const { accountInfo } = useGlobalContext();
  const {
    application: { hasAppeal, hasTransfer },
    applicationBase,
  } = useApplicationContext();

  function showEdit() {
    return (
      props.disabled && !hasAppeal && !hasTransfer && (accountInfo.isInternal || (accountInfo.isKindergarten && applicationBase.canKindergartenEdit))
    );
  }

  return (
    <BaseComponent
      {...props}
      showNoValidateBtn={props.showNoValidateBtn ?? applicationBase.isPresubmission}
      showEdit={props.showEdit ?? showEdit()}
      submitBtnTitle={(props.showNoValidateBtn ?? applicationBase.isPresubmission) ? "Check this Section for Errors" : props.submitBtnTitle}
    />
  );
}
